import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IMenuItem } from '@src/slide/application/service/menu-manager/menu-items/menu-items.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { AddonMode } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import * as PropertyMenu from '@editor/src/js/constants/property-editor-data';

/**
 * 获取右侧编辑栏菜单
 * @param model 图形 uiModel
 */
export function getPropertyMenuItems(model: IBaseModel | INoteModel): IMenuItem[] {
    const modelType = model.type;
    // 空白
    if ([UIModelType.EMPTY].includes(modelType)) {
        return PropertyMenu.BlankPropertyItems;
    }
    // 备注
    if ([UIModelType.NOTE].includes(modelType)) {
        return PropertyMenu.BlankPropertyItems;
    }
    // 连接线
    if ([UIModelType.CONNECTOR].includes(modelType)) {
        return PropertyMenu.ConnectorPropertyItems;
    }
    // 表格
    if ([UIModelType.TABLE].includes(modelType)) {
        return PropertyMenu.TablePropertyItems;
    }
    // 图表
    if ([UIModelType.CHART].includes(modelType)) {
        return [];
    }
    // 图片
    if ([UIModelType.IMAGE].includes(modelType)) {
        return (model as IPictureModel).isMedia() ? [] : PropertyMenu.ImagePropertyItems;
    }
    // 形状
    if ([UIModelType.SHAPE].includes(modelType)) {
        return getShapePropertyMenuItems(model as IShapeModel);
    }
    return PropertyMenu.CommonPropertyItems;
}

/**
 * 获取形状顶部工具栏
 * @param model 图形 uiModel
 */
function getShapePropertyMenuItems(model: IShapeModel): IMenuItem[] {
    const shapeModel = model;
    const isIframe = shapeModel.props?.addon?.displayMode === AddonMode.IFRAME || false;
    if (isIframe) {
        return [];
    }
    if (shapeModel.isAttachment()) {
        if (shapeModel.isAttachmentUploaded()) {
            const enableFeatures = [ActionType.TEXT_ADJUST, ActionType.SIZE_ADJUST];
            return PropertyMenu.CommonPropertyItems.filter(item => !enableFeatures.includes(item.id));
        }
        return [];
    }
    return PropertyMenu.CommonPropertyItems;
}
